import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { useApiClient } from '../lib/use-api-client.js';

interface DeleteTenantAdminInput {
  clientId: string;
  userOid: string;
}

/** Mutation for `DELETE /v1/clients/{clientId}/admins/{userOid}` (Admin only). */
export function useDeleteTenantAdminMutation(): UseMutationResult<
  void,
  Error,
  DeleteTenantAdminInput
> {
  const api = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ clientId, userOid }: DeleteTenantAdminInput) => {
      if (!api) throw new Error('useDeleteTenantAdminMutation: api client unavailable');
      return api.delete<void>(`/v1/clients/${clientId}/admins/${userOid}`);
    },
    onSuccess: (_data, { clientId }) => {
      void queryClient.invalidateQueries({ queryKey: ['tenant-admins', clientId] });
    },
  });
}
